import { jsx as _jsx } from "react/jsx-runtime";
import { Flex, forwardRef } from '@chakra-ui/react';
import { useContext } from 'react';
import { Context } from './context';
export const TimelineItem = forwardRef((props, ref) => {
    const { orientation, size } = useContext(Context);
    return (_jsx(Flex, { ref: ref, alignItems: "center", justifyContent: "center", flexDirection: orientation === 'horizontal' ? 'row' : 'column', sx: {
            ...(size === 'fill' && {
                ':not(:last-of-type)': {
                    flex: 1,
                },
            }),
        }, ...props }));
});
